import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

// Dedicated axios instance with cookies enabled so the session cookie travels.
export const adminApi = axios.create({
  baseURL: ADMIN_API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function adminLogin(email, password) {
  const { data } = await adminApi.post("/auth/login", { email, password });
  return data;
}

export async function adminLogout() {
  const { data } = await adminApi.post("/auth/logout", {});
  return data;
}

export async function adminMe() {
  const { data } = await adminApi.get("/auth/me");
  return data;
}

export async function listLeads(params = {}) {
  const { data } = await adminApi.get("/leads", { params });
  return data;
}

export async function getLead(id) {
  const { data } = await adminApi.get(`/leads/${id}`);
  return data;
}

export async function patchLead(id, patch) {
  const { data } = await adminApi.patch(`/leads/${id}`, patch);
  return data;
}

export async function addNote(id, body) {
  const { data } = await adminApi.post(`/leads/${id}/notes`, { body });
  return data;
}

export async function syncLeadToDynamics(id) {
  const { data } = await adminApi.post(`/leads/${id}/sync-dynamics`, {});
  return data;
}

export async function bulkSyncToDynamics(leadIds) {
  const { data } = await adminApi.post(`/leads/bulk-sync-dynamics`, { lead_ids: leadIds });
  return data;
}

export async function getAdminSettings() {
  const { data } = await adminApi.get("/settings");
  return data;
}

export async function testDynamicsConnection() {
  const { data } = await adminApi.post("/settings/test-dynamics", {});
  return data;
}

export async function testEmailSend() {
  const { data } = await adminApi.post("/settings/test-email", {});
  return data;
}

export function exportLeadsCsvUrl(params = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "all")
  ).toString();
  return `${ADMIN_API}/leads/export.csv${qs ? `?${qs}` : ""}`;
}
